<template>
  <div class="shareholder-wrap" v-if="showTanksPage">
    <h2 class="shareholder-hd">관계사 프로모션 이용권 구매가<br>완료되었습니다.</h2>
    <div class="shareholder-noti-list">
      <ul>
        <li>프로모션 혜택 할인은 프로모션 페이지에서 구매 시에만 혜택 적용됩니다.</li>
        <li>일반 이용권 페이지에서 구매 시 정상 가격으로 결제됩니다.</li>
        <li>이용권 해지 후 만료 시 이메일 인증이 해지 됩니다.</li>
        <li>이메일 인증이 해지 된 경우 프로모션 이용권 재구매 시 다시 이메일 인증이 필요합니다.</li>
      </ul>
    </div>
    <div class="button-wrap">
      <a href="#" @click.prevent="moveToWavveHome">Wavve 홈 가기</a>
    </div>
  </div>
</template>
<script>
import { get } from 'lodash'
import utils from '@/common/util/utils'
import { UserService } from '@/common/api/api.service'
import { PATH_NAME_VOUCHER } from '@/common/router.const'

export default {
  name: 'Complete',
  data () {
    return {
      showTanksPage: false
    }
  },
  methods: {
    moveToWavveHome () {
      utils.login.logoutProc().then(() => {
        location.href = 'https://www.wavve.com'
      }).catch(() => {
        location.href = 'https://www.wavve.com'
      })
    },
    checkProduct () {
      const targetProductList = ['pk_1897', 'pk_1898']
      UserService.userPurchaseProducts({
        productType: 'all',
        autoPayment: 'all',
        orderBy: 'all',
        offset: 0,
        limit: 10
      }).then(({ data }) => {
        const alreadyHaveProducts = get(data, 'list', [])
        const isBuySuccess = alreadyHaveProducts.filter((product) => {
          const id = get(product, 'productid', '')
          return targetProductList.indexOf(id) > -1
        })
        if (isBuySuccess.length === 0) {
          this.$router.replace({ name: PATH_NAME_VOUCHER, query: { promotioncode: 'forholder' } })
        } else {
          this.showTanksPage = true
        }
      })
    }
  },
  created () {
    this.checkProduct()
  }
}
</script>
